import { makeAutoObservable } from 'mobx';
import type { BibleLocation } from '@skjv/common';
import { MemoryVerseFrequency } from '@skjv/common';
import { saveMemoryVerse, loadMemoryVerse } from '../persistence';

/**
 * Memory verse state management.
 */
export class MemoryVerseState {
  /** Memory verse location */
  memoryVerse: BibleLocation | null = null;

  /** Memory verse frequency */
  memoryVerseFrequency: MemoryVerseFrequency = MemoryVerseFrequency.APP_LOAD;

  /** Memory verse last shown timestamp */
  memoryVerseLastMillis: number | null = null;

  constructor() {
    makeAutoObservable(this);

    if (typeof window !== 'undefined') {
      const data = loadMemoryVerse();
      if (data) {
        this.memoryVerse = data.verse as BibleLocation | null;
        this.memoryVerseFrequency = data.frequency ?? MemoryVerseFrequency.APP_LOAD;
        this.memoryVerseLastMillis = data.lastMillis;
      }
    }
  }

  /** Set memory verse */
  setMemoryVerse(location: BibleLocation): void {
    this.memoryVerse = location;
    this.memoryVerseLastMillis = Date.now();
    this.save();
  }

  /** Remove memory verse */
  removeMemoryVerse(): void {
    this.memoryVerse = null;
    this.memoryVerseLastMillis = null;
    this.save();
  }

  /** Set memory verse frequency */
  setMemoryVerseFrequency(frequency: MemoryVerseFrequency): void {
    this.memoryVerseFrequency = frequency;
    this.save();
  }

  private save(): void {
    saveMemoryVerse({
      verse: this.memoryVerse,
      frequency: this.memoryVerseFrequency,
      lastMillis: this.memoryVerseLastMillis,
    });
  }
}
